import { FOREACH_SENTINEL_ID } from "../nodes/loop/loopTypes";
import type { RuleEdgeData, RuleEdgeProps } from "../types/edges";
import BaseEdge, { EDGE_STROKE, EdgeAddButtonLayer } from "./BaseEdge";
import {
	FOR_EACH_RETURN_VERTICAL_DROP,
	getForEachReturnEdgeAddButtonPosition,
	getForEachReturnPathD,
} from "./bezierEdgeUtils";

const PILL_WIDTH = 60;
const PILL_HEIGHT = 24;
const HALF_PILL_WIDTH = PILL_WIDTH / 2;
const HALF_PILL_HEIGHT = PILL_HEIGHT / 2;

const DecisionTrueEdge = (props: RuleEdgeProps) => {
	/** Legacy only: true → Loop Start `in` before Continue sentinel existed. */
	const isReturnToForeachLegacy =
    props.target === FOREACH_SENTINEL_ID &&
    (props.targetHandleId === "in" || props.targetHandleId == null);

	const data: RuleEdgeData = {
		...props.data,
		label: "True",
		color: "#02D5AB",
		addButtonBetweenPillAndMarker: !isReturnToForeachLegacy,
	};

	if (!isReturnToForeachLegacy) {
		return (
			<>
				<BaseEdge {...props} data={{ ...data, disableAddButton: true }} />
				{!props.data?.disableAddButton && (
					<EdgeAddButtonLayer
						id={props.id}
						source={props.source}
						target={props.target}
						sourceHandleId={props.sourceHandleId}
						sourceX={props.sourceX}
						sourceY={props.sourceY}
						targetX={props.targetX}
						targetY={props.targetY}
						sourcePosition={props.sourcePosition}
						targetPosition={props.targetPosition}
						data={data}
					/>
				)}
			</>
		);
	}

	const { d } = getForEachReturnPathD(props.sourceX, props.sourceY, props.targetX, props.targetY);
	const addPos = getForEachReturnEdgeAddButtonPosition(
		props.sourceX,
		props.sourceY,
		props.targetX,
		props.targetY,
	);
	const cornerY = props.sourceY + FOR_EACH_RETURN_VERTICAL_DROP;
	/** Same SVG layer as BaseEdge pill; avoid HTML EdgeLabelRenderer wrapper (breaks `<g>` flow coords). */
	const labelX = props.sourceX;
	const labelY = props.sourceY + (cornerY - props.sourceY) * 0.28;
	const pillColor = data.color ?? "#666666";

	return (
		<>
			<path
				id={props.id}
				d={d}
				style={{
					stroke: EDGE_STROKE,
					strokeWidth: 2.5,
					fill: "none",
					...(props.style ?? {}),
				}}
				markerEnd={props.markerEnd}
			/>

			<g
				transform={`translate(${labelX}, ${labelY})`}
				style={{ pointerEvents: "none", userSelect: "none" }}
			>
				<rect
					x={-HALF_PILL_WIDTH}
					y={-HALF_PILL_HEIGHT}
					width={PILL_WIDTH}
					height={PILL_HEIGHT}
					rx={6}
					ry={6}
					fill="#fff"
				/>
				<rect
					x={-HALF_PILL_WIDTH}
					y={-HALF_PILL_HEIGHT}
					width={PILL_WIDTH}
					height={PILL_HEIGHT}
					rx={6}
					ry={6}
					fill={pillColor}
					fillOpacity={0.12}
					stroke={pillColor}
					strokeWidth={1.5}
				/>
				<text
					textAnchor="middle"
					dominantBaseline="middle"
					style={{
						fontSize: "0.75rem",
						fontWeight: 400,
						fill: pillColor,
						fontFamily: "Roboto, sans-serif",
					}}
				>
          True
				</text>
			</g>

			{!props.data?.disableAddButton && (
				<EdgeAddButtonLayer
					id={props.id}
					source={props.source}
					target={props.target}
					sourceHandleId={props.sourceHandleId}
					sourceX={props.sourceX}
					sourceY={props.sourceY}
					targetX={props.targetX}
					targetY={props.targetY}
					data={data}
					addButtonScreenPosition={addPos}
				/>
			)}
		</>
	);
};

export default DecisionTrueEdge;